import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import DancingLines from "react-dancing-lines";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <DancingLines />
    <App />
  </React.StrictMode>
);
